import React, { useState } from 'react';

import { NotificationsTypeSelector } from '../shared/Selectors.js'
import { UsersListSelector} from '../shared/ListSelector.js'




export default function NotificationForm({save, isLoading }) {
  const [selectedUsers, setSelectedUsers] = useState([])
  const [alertType, setalertType] = useState('')
  const [errors, setErrors] = useState({});

  const validations = [];

  function validate(e) {
    e.preventDefault();
    
    const validations = [];

    if (selectedUsers.length === 0) {
      validations.push(['userId', 'Debes seleccionar al menos un usuario']);
    }

    if (!alertType) {
      validations.push(['alertType', 'Debes seleccionar un tipo de alerta']);
    }


   
    if (validations.length > 0) {
      setErrors(validations.reduce((acc, item) => ({ ...acc, [item[0]]: item[1] }), {}));
      console.log({validations})
      return;
    } else {
      setErrors([])
      const data = {
        selectedUsers,
        alertType
      }
      save(data);
    }
  }

  return (
    <form onSubmit={validate}>
      <div className="row mb-3 ">
          <UsersListSelector
            onChange={items => setSelectedUsers(items)}
          />
        {errors.userId && <div className="invalid-feedback d-block">{errors.userId}</div>}
      </div>


      <div className="form-group">
        <label>Tipo de alerta</label>
          <NotificationsTypeSelector
            disabled={isLoading}
            onChange={alertTypeId => setalertType(alertTypeId)}
            placeholder="Selecciona un tipo de notificación"
            defaultValue={alertType}
          />
        {errors.alertType && <div className="invalid-feedback d-block">{errors.alertType}</div>}
      </div>

      <div className="form-group">
        <button className={`btn btn-primary ${isLoading ? 'loading' : ''}`} disabled={isLoading}>
          <span>Guardar</span>
          <div className='spinner-border' role='status'></div>
        </button>
      </div>
    </form>
  )
};
